// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"94c66eaa","983":"3e09d75d"}[chunkId] + ".chunk.js";
};